class ControleAbasService {
	constructor() {
		this.maximoAbas = 2;
		this.idAba = this.gerarIdAba();
		this.chaveStorage = "abas_ativas";
		this.timeoutInatividadeMs = 5 * 60 * 1000; // 5 minutos
		this.timeoutStaleMs = 45 * 1000; // tempo curto para limpar abas que não atualizam
		this.heartbeatMs = 10000; // intervalo de manutenção/checagem
		this.observadores = new Set();
		this.rotasExcecao = ["/auth/vistoria-public"];
		this.inicializar();
	}

	gerarIdAba() {
		return (
			"aba_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9)
		);
	}

	estaEmRotaExcecao() {
		const urlAtual = window.location.pathname;
		const hashAtual = window.location.hash;

		return this.rotasExcecao.some(
			(rota) => urlAtual.includes(rota) || hashAtual.includes(rota),
		);
	}

	adicionarObservador(callback) {
		this.observadores.add(callback);
	}

	removerObservador(callback) {
		this.observadores.delete(callback);
	}

	notificarObservadores() {
		this.observadores.forEach((callback) => callback());
	}

	inicializar() {
		// Se estiver em rota de exceção, não aplica controle de abas
		if (this.estaEmRotaExcecao()) {
			return;
		}

		this.limparAbasInativas();
		this.registrarAba();

		window.addEventListener("beforeunload", () => {
			this.removerAba();
		});

		window.addEventListener("pagehide", () => {
			this.removerAba();
		});

		window.addEventListener("unload", () => {
			this.removerAba();
		});

		window.addEventListener("blur", () => {
			this.atualizarAtividade();
		});

		window.addEventListener("focus", () => {
			this.atualizarAtividade();
		});

		document.addEventListener("visibilitychange", () => {
			this.atualizarAtividade(document.visibilityState === "visible");
		});

		setInterval(() => {
			this.atualizarAtividade(true);
			const excedeuLimite = this.contarAbas() > this.maximoAbas;
			this.limparAbasInativas({ usarTimeoutCurto: excedeuLimite });

			if (this.contarAbas() > this.maximoAbas) {
				this.notificarObservadores();
			}
		}, this.heartbeatMs);
	}

	registrarAba() {
		const abas = this.obterAbas();
		// Verifica se a aba atual já está registrada (evita duplicatas ao recarregar)
		const abaExistente = abas.find((aba) => aba.id === this.idAba);

		if (abaExistente) {
			// Se já existe, apenas atualiza a atividade
			abaExistente.ultimaAtividade = Date.now();
			this.salvarAbas(abas);
		} else {
			// Remove apenas abas inativas da mesma URL (caso a página tenha sido recarregada)
			// Mantém abas ativas da mesma URL (permite duplicar abas)
			const urlAtual = window.location.href;
			const agora = Date.now();
			const timeout = this.timeoutInatividadeMs;

			const abasFiltradas = abas.filter((aba) => {
				// Mantém todas as abas de URLs diferentes
				if (aba.url !== urlAtual) {
					return true;
				}
				// Mantém abas ativas da mesma URL (permite múltiplas abas da mesma URL)
				if (agora - aba.ultimaAtividade < timeout) {
					return true;
				}
				// Remove apenas abas inativas da mesma URL
				return false;
			});

			const novaAba = {
				id: this.idAba,
				timestamp: Date.now(),
				ultimaAtividade: Date.now(),
				url: urlAtual,
			};

			abasFiltradas.push(novaAba);
			this.salvarAbas(abasFiltradas);
		}
	}

	removerAba() {
		const abas = this.obterAbas();
		const abasFiltradas = abas.filter((aba) => aba.id !== this.idAba);
		this.salvarAbas(abasFiltradas);
	}

	atualizarAtividade(force = false) {
		const abas = this.obterAbas();
		const indice = abas.findIndex((aba) => aba.id === this.idAba);

		if (indice === -1) {
			if (force) {
				this.registrarAba();
			}
			return;
		}

		abas[indice].ultimaAtividade = Date.now();
		this.salvarAbas(abas);
	}

	limparAbasInativas({ usarTimeoutCurto = false } = {}) {
		const abas = this.obterAbas();
		const agora = Date.now();
		const timeoutLongo = this.timeoutInatividadeMs;
		const timeoutCurto = usarTimeoutCurto ? this.timeoutStaleMs : null;

		const abasAtivas = abas.filter((aba) => {
			const diff = agora - aba.ultimaAtividade;
			if (timeoutCurto && diff >= timeoutCurto) {
				return false;
			}
			return diff < timeoutLongo;
		});

		if (abasAtivas.length !== abas.length) {
			this.salvarAbas(abasAtivas);
		}
	}

	obterAbas() {
		try {
			const abas = localStorage.getItem(this.chaveStorage);
			return abas ? JSON.parse(abas) : [];
		} catch (error) {
			console.error("Erro ao obter abas ativas:", error);
			return [];
		}
	}

	salvarAbas(abas) {
		try {
			localStorage.setItem(this.chaveStorage, JSON.stringify(abas));
		} catch (error) {
			console.error("Erro ao salvar abas ativas:", error);
		}
	}

	contarAbas() {
		return this.obterAbas().length;
	}

	deveMostrarAviso() {
		// Se estiver em rota de exceção, nunca mostra aviso
		if (this.estaEmRotaExcecao()) {
			return false;
		}
		return this.contarAbas() > this.maximoAbas;
	}
}

const controleAbasService = new ControleAbasService();

export default controleAbasService;
